import { Entity } from '../entity';
import { JobViewFilters, PriorityTiny } from '../job';
import { FilterValue } from '../shared';
import { JobType } from '../tenant';
import { Distance, WorkOrderSortOption } from './scheduling.work.order';

export interface SchedulingRefiners {

    billingCompanies?: Entity[];
    customers?: Entity[];
    categories?: Entity[];
    workCategories?: Entity[];
    jobTypes: JobType[];
    priorities: PriorityTiny[];

    dueDate: any;
    createdDate: any;

    owners: Entity[];
    zones: Entity[];
    tags?: Entity[];
    jobTags?: Entity[];
    search?: string;

    total?: number;
    pageTotal?: number;

}

export interface SchedulingRefinements extends Pick<
    Partial<JobViewFilters>,
    'text'
    | 'billingCompanies'
    | 'customers'
    | 'workCategories'
    | 'jobTypes'
    | 'priorities'
    | 'dueDate'
    | 'stageDueDate'
    | 'createdAt'
    | 'owners'
    | 'zones'
> {

    tags?: FilterValue[];
    jobTags?: FilterValue[];
    categories?: FilterValue[];
    distance?: Distance;
    sort?: WorkOrderSortOption;
}

export const defaultSchedulingRefinements: { [k in keyof SchedulingRefinements]: any } = {
    text: null,

    billingCompanies: [],
    customers: [],

    categories: [],
    workCategories: [],

    jobTypes: [],
    priorities: [],

    dueDate: null,
    stageDueDate: null,
    createdAt: null,

    owners: [],
    tags: [],
    jobTags: [],
    zones: [],

    distance: null,
}